import { Component, Input, OnInit } from '@angular/core';
import { KioskPropertiesGA4Int } from '@app/interfaces/ga4.interface';
import { Ga4Service } from '@app/services/ga4.service';
import { UrlService } from '@app/services/url.service';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
/**
 * Componente de alerta para el disclaimer de Premier.
 * 
 * Este componente muestra un mensaje informativo sobre la política de equipaje para los usuarios de Premier,
 * permitiendo cerrar el modal o redirigir a la compra de equipaje adicional.
 */
@Component({
    selector: 'app-alert-premier-disclaimer',
    templateUrl: './alert-premier-disclaimer.component.html',
    styleUrls: ['./alert-premier-disclaimer.component.scss'],
    standalone: false
})
export class AlertPremierDisclaimerComponent implements OnInit {
  /** Opciones de configuración del modal */
  @Input() options = {
    buyMoreBags: false,
    hasPrePaidBags: false,
    totalBags32: 0
  };

  title: string;
  subtitle: string;
  
  constructor(
    public modal: NgbActiveModal,
    private _urlService: UrlService,
    private _ga4Service: Ga4Service
  ) { }

  ngOnInit(
  ): void {
    const optionTitle = this.options.buyMoreBags ? 'addluggagee' : 'withoutluggagee';
    const optionSubtitle = this.options.hasPrePaidBags ? 'prePaid' : 'withoutPrepaid';

    this.title = `modalPremierDisclaimer.${ optionTitle }.title`;
    this.subtitle = `modalPremierDisclaimer.${ optionSubtitle }.subTitle`;

    if (this.options.buyMoreBags) {
      const userPropertiesModal: KioskPropertiesGA4Int = {
        page_location: this._urlService.currentUrl,
        page_referrer: this._urlService.beforeUrl,
        screen_resolution: '1280x1024',
        sub_funnel_name: 'modal_premierluggage'
      };
  
      this._ga4Service.sendKioskPropertiesEvent(userPropertiesModal);
    }
  }
  
  onClose() {
    this.modal.close();
  }

  onBuyBags() {
    this.modal.close({ buyMore: true });
  }
}
